import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import { useEffect, useState } from "react";
import { acceptCookieConsent } from "helpers";
import { COOKIE_NAME } from "config";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    declineButton: {
      background: "#000E1C",
      padding: "10px 30px",
      boxShadow: "0 0 10px 5px rgba(65, 32, 186, 0.5)",
      borderRadius: 11,
      border: "3px solid #4120ba",
      color: "rgba(255, 255, 255, 0.8)",
      boxSizing: "border-box",
      flex: "1",
      margin: "10px",
      cursor: "pointer",
      fontFamily: "Cano, sans-serif",
      "& *": {
        fontWeight: 400,
        letterSpacing: 8.89554,
        textShadow: "0.849354px 0.849354px 4.24677px rgba(255, 255, 255, 0.6)",
        fontSize: 14,
        [theme.breakpoints.down("xs")]: {
          fontSize: 10,
        },
      },
      "&:hover, &:focus": {
        background: "#000E1C",
        boxShadow: "0 0 10px 10px rgba(65, 32, 186, 0.5)",
      },
    },
    acceptButton: {
      background: "linear-gradient(180deg, #FFE600 0%, #FF8A00 100%)",
      padding: "10px 30px",
      boxShadow: "0px 2.96518px 2.96518px rgba(0, 0, 0, 0.25)",
      borderRadius: 11,
      border: "none",
      flex: "1",
      margin: "10px",
      cursor: "pointer",
      color: "rgba(0, 0, 0, 1)",
      fontFamily: "Cano, sans-serif",
      "& *": {
        fontWeight: 700,
        textIndent: 9,
        letterSpacing: 9,
        color: "#002F43",
        textShadow: "0px 3.91041px 3.91041px rgba(0, 0, 0, 0.25)",
        fontSize: 14,
        [theme.breakpoints.down("xs")]: {
          fontSize: 10,
        },
      },
      "&:hover, &:focus": {
        background: "linear-gradient(180deg, #FFE600 0%, #FF8A00 100%)",
        boxShadow: "0 0 10px 10px rgba(65, 32, 186, 0.5)",
      },
    },
  }),
);

/** Fixed bottom-right cookie consent banner. Hides itself once consent is given or declined. */
export default function CookieConsentBanner() {
  const classes = useStyles();
  const [hidden, setHidden] = useState(
    () => getCookieConsentValue(COOKIE_NAME) === "true",
  );

  useEffect(() => {
    if (getCookieConsentValue(COOKIE_NAME) === "true") {
      acceptCookieConsent();
    }
    const handler = () => setHidden(true);
    window.addEventListener("cookieConsentAccepted", handler);
    return () => window.removeEventListener("cookieConsentAccepted", handler);
  }, []);

  if (hidden) return null;

  return (
    <CookieConsent
      visible="byCookieValue"
      location="bottom"
      buttonText="ACCEPT"
      cookieName={COOKIE_NAME}
      style={{
        background: "#000E1C",
        color: "#ffffff",
        borderRadius: 11,
        boxShadow: "0 0 10px 5px rgba(65, 32, 186, 0.5)",
        zIndex: 9999,
        padding: "20px",
        width: "auto",
        margin: "30px",
        display: "flex",
        gap: "15px",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        right: "0px",
        position: "fixed",
        fontWeight: 500,
      }}
      disableStyles={true}
      disableButtonStyles={true}
      buttonClasses={classes.acceptButton}
      expires={365}
      enableDeclineButton
      declineButtonText="DECLINE"
      declineButtonClasses={classes.declineButton}
      onAccept={acceptedByScrolling => {
        if (!acceptedByScrolling) {
          acceptCookieConsent();
        }
        setHidden(true);
      }}
    >
      We use cookies to enhance your experience.
      <p>
        For more information, read our&nbsp;
        <a
          style={{ color: "#FFE600" }}
          href="https://www.brickabode.com/privacy-policy.html"
        >
          Privacy Policy
        </a>
        .
      </p>
    </CookieConsent>
  );
}
